import React from "react";
import { Wifi, WifiOff, Clock } from "lucide-react";

const OfflineIndicator = ({ isOnline, pendingCount }) => {
  if (isOnline && pendingCount === 0) {
    return null;
  }

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-50 p-3 ${
        isOnline ? "bg-warning-500 text-white" : "bg-error-500 text-white"
      }`}
    >
      <div className="max-w-md mx-auto flex items-center justify-center gap-2">
        {isOnline ? (
          <>
            <Clock className="w-4 h-4" />
            <span className="text-sm font-medium">
              {pendingCount} action{pendingCount !== 1 ? "s" : ""} pending sync
            </span>
          </>
        ) : (
          <>
            <WifiOff className="w-4 h-4" />
            <span className="text-sm font-medium">
              Offline - Actions will be saved locally
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default OfflineIndicator;
